import { httpService } from "../common/HttpService";

class MarketListsService {

    constructor() { }

    getMarketsList() {
        return httpService.get("/markets");
    }
   

}

export const marketListsService = new MarketListsService();